import React from "react";
import {ProductElementModifier} from "../../providers/product/product-types";
import {useTranslation} from "react-i18next";

export interface AddModifiersButtonProps {
    modifiers: ProductElementModifier[];
    onClick: () => void;
}

export const AddModifiersButton = ({modifiers, onClick}: AddModifiersButtonProps) => {
    const {t} = useTranslation();

    if(modifiers.length === 0) {
        return null;
    }

    return (
        <button
            type="button"
            onClick={onClick}
            className="rounded-md w-full bg-indigo-50 px-3 py-2 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-100"
        >
            {t('CONFIG.ADD_MODIFIER')}
        </button>
    )
}